import { getUrlWithVariant, ProductForm } from '@shopify/theme-product-form';

import Cart from '../cart/Cart';
import { rootPath, theme } from '../../constants/defaults';
import { formatMoney } from '../../utils/product';
import quantitySelect from '../layout/quantitySelect';

export default class AddToCart {
  constructor(form) {
    this.cart = Cart.getInstance();

    this.productFormElement = form;
    this.noteElement = this.productFormElement.querySelector('.note');
    this.addToCartTriggers = [...this.productFormElement.querySelectorAll('.js-add-to-cart')];

    // Quick add mobile buttons
    if (this.productFormElement) {
      const closestWrapper = this.productFormElement.closest('.product__wrapper');

      if (closestWrapper) {
        const quickAddMobileButton = closestWrapper.querySelector('.js-add-to-cart-reveal');

        quickAddMobileButton.addEventListener('click', () => {
          const attribute = quickAddMobileButton.getAttribute('data-quick-add-button');
          const quickAddMobileForm = document.querySelector(`[data-quick-add-form='${attribute}']`);

          if (quickAddMobileForm.classList.contains('product__quick-add-to-cart--visible')) {
            quickAddMobileForm.classList.remove('product__quick-add-to-cart--visible');
          } else {
            quickAddMobileForm.classList.add('product__quick-add-to-cart--visible');
          }
        });
      }
    }

    this.initProductForm(this.productFormElement);
    this.addToCart(this.productFormElement);
    quantitySelect([...form.querySelectorAll('.js-quantity-select')]);
  }

  initProductForm(formEl) {
    const { productHandle } = this.productFormElement.dataset;
    const requestUrl = `${rootPath}products/${productHandle}.js`;

    fetch(requestUrl)
      .then((response) => response.json())
      .then((productJSON) => {
        const productFormObj = new ProductForm(formEl, productJSON, {
          onOptionChange: (e) => this.onOptionChange(e, formEl, productFormObj),
          onFormSubmit: (e) => this.onFormSubmit(e, formEl, productFormObj),
        });
      })
      .catch(() => {
        //  console.log(e);
      });
  }

  enableAddToCartTriggers() {
    this.addToCartTriggers.forEach((trigger) => {
      trigger.removeAttribute('disabled');
      trigger.innerHTML = theme.strings.addToCart;
    });
  }

  disableAddToCartTriggers() {
    this.addToCartTriggers.forEach((trigger) => {
      trigger.setAttribute('disabled', 'disabled');
      trigger.innerHTML = theme.strings.soldOut;
    });
  }

  onOptionChange(event, formEl) {
    const { variant } = event.dataset;
    const noteEl = formEl.querySelector('.note');
    this.hideNoteElement(noteEl);

    // Skip when there is no variant selected
    if (!variant) {
      return;
    }

    if (variant.featured_image) {
      this.slider = window.slider['product-slider'];
      const slides = [...this.slider.$el[0].querySelectorAll('.swiper-slide')];
      const newSlide = this.slider.$el[0].querySelector(
        `[data-variant-image-id="${variant.featured_image.id}"]`,
      );
      const index = slides.indexOf(newSlide);

      this.slider.slideTo(index, 1000);
    }

    if (variant.available) {
      this.enableAddToCartTriggers();
    } else {
      this.disableAddToCartTriggers();
    }

    [...document.querySelectorAll('.js-product-price')].forEach((priceEl) => {
      priceEl.innerHTML = formatMoney(variant.price);
    });

    [...document.querySelectorAll('.js-product-compare-price')].forEach((comparePriceEl) => {
      if (variant.compare_at_price > variant.price) {
        comparePriceEl.innerHTML = formatMoney(variant.compare_at_price);
        comparePriceEl.classList.remove('hide');
      } else {
        comparePriceEl.innerHTML = '';
        comparePriceEl.classList.add('hide');
      }
    });

    const url = getUrlWithVariant(window.location.href, variant.id);
    window.history.replaceState({ path: url }, '', url);
  }

  hideNoteElement(noteEl) {
    noteEl.classList.add('hide');
    noteEl.classList.remove('note--success');
    noteEl.classList.remove('note--error');
    noteEl.innerHTML = '';
  }

  showNoteElement(message, isSuccess, noteEl) {
    if (isSuccess) {
      noteEl.classList.add('note--success');
    } else {
      noteEl.classList.add('note--error');
    }

    noteEl.innerHTML = message;
    noteEl.classList.remove('hide');
  }

  onFormSubmit(e) {
    e.preventDefault();
    const { variant, quantity, properties } = e.dataset;
    const item = { id: variant.id, quantity, properties };
    // const productObject = formObj.product;
    window.currentlySubmittedProductFormEl = this.productFormElement;
    this.cart.addItems(item);
  }

  addToCart(formEl) {
    const addToCartTrigger = formEl.querySelector('.js-add-to-cart');
    let noteEl = formEl.querySelector('.note');
    this.cart.on('adding', () => {
      if (addToCartTrigger) {
        addToCartTrigger.classList.add('loading');
      }
      if (window.currentlySubmittedProductFormEl) {
        noteEl = window.currentlySubmittedProductFormEl.querySelector('.note');
        this.hideNoteElement(noteEl);
      }
    });

    this.cart.on('added', () => {
      if (addToCartTrigger) {
        addToCartTrigger.classList.remove('loading');
      }
      if (window.currentlySubmittedProductFormEl) {
        noteEl = window.currentlySubmittedProductFormEl.querySelector('.note');
      }
      this.showNoteElement(theme.strings.successAddToCart, true, noteEl);
    });

    this.cart.on('error_add_item', (error) => {
      addToCartTrigger.classList.remove('loading');
      noteEl = window.currentlySubmittedProductFormEl.querySelector('.note');
      if (error.status === 422) {
        if (noteEl) {
          this.showNoteElement(error.description, false, noteEl);
        }
      } else if (noteEl) {
        this.showNoteElement(theme.strings.errorAddToCart, false, noteEl);
      }
    });
  }
}
